export const margin = 'dense'; //dense, normal
export const variant = 'outlined'; //outlined, filled

const regexOnlyNumbers = /^[0-9]*$/;

export const formSteps = {
    ID_PHONE: 'ID_PHONE',
    SMS_CODE: 'SMS_CODE',
    LOAN_OPTIONS: 'LOAN_OPTIONS',
    ID_DATA: 'ID_DATA',
    ADDRESS: 'ADDRESS',
    ID_VERIFICATION_NOTICE: 'ID_VERIFICATION_NOTICE',
    PHOTO_UPLOAD: 'PHOTO_UPLOAD',
    ID_FILES_UPLOAD: 'ID_FILES_UPLOAD',
    FINAL: 'FINAL',
};

export const formVariants = {
    loan: [
        formSteps.ID_PHONE,
        formSteps.SMS_CODE,
        formSteps.LOAN_OPTIONS,
        formSteps.ID_DATA,
        formSteps.ADDRESS,
        formSteps.ID_VERIFICATION_NOTICE,
        formSteps.PHOTO_UPLOAD,
        formSteps.ID_FILES_UPLOAD,
        formSteps.FINAL,
    ]
}

export const defaultData = {
    [formSteps.ID_PHONE]: {
        nombre: '',
        apellido: '',
        ci: '',
        userFechaNac: '',
        sexo: '',
        ocupacion: '',
        rut: '',
        antiguedad: '',
        ingresos: '',
        hasReciboSueldo: null,
        email: '',
        telMovil: '',
        agreeTerms: false,
    },
    [formSteps.SMS_CODE]: {
        userCodigoValidacion: '',
        userFechaNac: '',
    },
    [formSteps.LOAN_OPTIONS]: {
        solicitudTipo: 0,
        financialProducto: 0,
        monto: 0,
        cantidadCuotas: 0,
        valorCuota: 0,
        diagramaPrimerVencimiento: '',
    },
    [formSteps.ID_DATA]: {
        estadoCivil: '',
        ciConcubino: '',
        nombreConcubino: '',
        apellidoConcubino: '',
        nacionalidad: '',
        nivelEstudio: '',
        nroSerie: '',
        nroIdentificacion: '',
        // inListaPep: null,
        agreeBeneficiarioFinal: false,
    },
    [formSteps.ADDRESS]: {
        direccionParticular: '',
        numeroPuerta: '',
        apartamento: '',
        departamento: '',
        ciudad: '',
        telParticular: '',
        telExtra: '',
        departamentoNac: '',
    }
};

export const validations = {
    [formSteps.ID_PHONE]: {
        nombre: {
            required: true,
            validate: 'text',
            requiredErrorText: 'El campo "Nombre" es obligatorio.'
        },
        apellido: {
            required: true,
            validate: 'text',
            requiredErrorText: 'El campo "Apellido" es obligatorio.'
        },
        ci: {
            required: true,
            validate: 'ci',
            requiredErrorText: 'El campo "Cédula de Identidad" es obligatorio.',
            regexReplace: regexOnlyNumbers
        },
        userFechaNac: {
            required: true,
            validate: 'dateBirth',
            requiredErrorText: 'El campo "Fecha de nacimiento" es obligatorio.'
        },
        ocupacion: {
            required: true,
            validate: 'select',
            requiredErrorText: 'El campo "Actividad Laboral" es obligatorio.'
        },
        rut: {
            required: true,
            validate: 'rut',
            requiredErrorText: 'El campo "RUT" es obligatorio.',
            regexReplace: regexOnlyNumbers
        },
        antiguedad: {
            required: true,
            validate: 'select',
            requiredErrorText: 'El campo "Antigüedad laboral" es obligatorio.'
        },
        ingresos: {
            required: true,
            validate: 'number',
            requiredErrorText: 'El campo "Ingreso líquido mensual" es obligatorio.',
            regexReplace: regexOnlyNumbers
        },
        hasReciboSueldo: {
            required: true,
            validate: 'select'
        },
        email: {
            required: false,
            validate: 'email',
            requiredErrorText: 'El campo "Correo Electrónico" es obligatorio.'
        },
        sexo: {
            required: true,
            validate: 'select',
            requiredErrorText: 'El campo "Género" es obligatorio.'
        },
        telMovil: {
            required: true,
            validate: 'mobile',
            maxLength: 15,
            requiredErrorText: 'El campo "Teléfono celular" es obligatorio.'
        },
        agreeTerms: {
            required: true,
            validate: 'checkbox',
            helperText: 'Debés aceptar los "Términos y condiciones".'
        }
    },
    [formSteps.SMS_CODE]: {
        userCodigoValidacion: {
            required: true,
            validate: 'smsCode',
            regexReplace: regexOnlyNumbers
        },
        userFechaNac: {
            required: true,
            validate: 'dateBirth',
        }
    },
    [formSteps.ID_DATA]: {
        estadoCivil: {
            required: true,
            validate: 'select',
            requiredErrorText: 'El campo "Estado civil" es obligatorio.'
        },
        ciConcubino: {
            required: true,
            validate: 'ci',
            regexReplace: regexOnlyNumbers,
            requiredErrorText: 'El campo "CI de cónyuge o concubino/a" es obligatorio.'
        },
        nombreConcubino: {
            required: true,
            validate: 'text',
            requiredErrorText: 'El campo "Nombre cónyuge o concubino/a" es obligatorio.'
        },
        apellidoConcubino: {
            required: true,
            validate: 'text',
            requiredErrorText: 'El campo "Apellido cónyuge o concubino/a" es obligatorio.'
        },
        nacionalidad: {
            required: true,
            validate: 'select',
            requiredErrorText: 'El campo "Nacionalidad" es obligatorio.'
        },
        nivelEstudio: {
            required: true,
            validate: 'select',
            requiredErrorText: 'El campo "Nivel de estudio" es obligatorio.'
        },
        nroSerie: {
            required: false,
            validate: 'text',
        },
        nroIdentificacion: {
            required: false,
            validate: 'text',
        },
        // inListaPep: {
        //     required: true,
        //     validate: 'select',
        //     helperText: 'Este campo es requerido.'
        // },
        agreeBeneficiarioFinal: {
            required: true,
            validate: 'checkbox',
            helperText: 'Debés aceptar ser la persona "beneficiario/a final del préstamo".'
        }
    },
    [formSteps.ADDRESS]: {
        direccionParticular: {
            required: true,
            validate: 'text',
            requiredErrorText: 'El campo "Dirección particular" es obligatorio.'
        },
        numeroPuerta: {
            required: true,
            validate: 'text',
            requiredErrorText: 'El campo "N° puerta" es obligatorio.'
        },
        apartamento: {
            required: false,
            validate: 'text',
            requiredErrorText: 'El campo "Apartamento" es obligatorio.'
        },
        departamento: {
            required: true,
            validate: 'select',
            requiredErrorText: 'El campo "Departamento" es obligatorio.'
        },
        ciudad: {
            required: true,
            validate: 'select',
            requiredErrorText: 'El campo "Ciudad" es obligatorio.'
        },
        telParticular: {
            required: true,
            validate: 'phone',
            requiredErrorText: 'El campo "Teléfono particular" es obligatorio.',
            helperText: 'El campo "Teléfono particular" es incorrecto.',
        },
        telExtra: {
            required: false,
            validate: 'phone',
            requiredErrorText: 'El campo "Teléfono extra" es obligatorio.',
            helperText: 'El campo "Teléfono extra" es incorrecto.',
        },
        departamentoNac: {
            required: true,
            validate: 'select',
            requiredErrorText: 'El campo "Departamento de nacimiento" es obligatorio.'
        }
    }
};
